import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

const HEIGHT = 6;

const Layout = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: ${toRem(HEIGHT)};
  border-radius: ${toRem(HEIGHT / 2)};
  background-color: ${theme.color.neutral[200]};
  overflow: hidden;
`;

interface IProgressProps {
  width?: any;
}

const Progress = styled.span<IProgressProps>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: auto;
  background-color: ${theme.color.secondary[300]};
  transition: width ${theme.transition.nav};

  ${({ width }) =>
    width &&
    css`
      width: ${width}%;
    `}
`;

export interface ProgressBarProps {
  className?: string;
  currentStep: number;
  totalSteps: number;
}

const ProgressBar = ({ className, currentStep, totalSteps }: ProgressBarProps) => {
  const singleStepWidth = 100 / totalSteps;
  const getProgressWidth = (singleStepWidth * currentStep).toFixed(0);

  return (
    <Layout className={className}>
      <Progress width={getProgressWidth} />
    </Layout>
  );
};

export default ProgressBar;
